import { render, staticRenderFns } from "./wizardSteps.vue?vue&type=template&id=65f04786&"
import script from "./wizardSteps.vue?vue&type=script&lang=js&"
export * from "./wizardSteps.vue?vue&type=script&lang=js&"
import style0 from "./wizardSteps.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports